// Route wrapper — reads the :slug param and renders the standalone product
// screen. Keeps TennisProductScreen prop-driven (testable) while the router
// supplies the slug.
import { useParams } from "react-router-dom";
import { TennisProductScreen } from "./TennisProductScreen.tsx";

export function TennisProductRoute(): JSX.Element {
  const { slug = "" } = useParams();
  return <TennisProductScreen slug={slug} />;
}
